export default __webpack_public_path__ + "static/media/Wells Fargo Grey.a784328c.png";